<template>
  <div class="wrap">
    <div class="container">
      <div class="top-row">
        <i class="el-icon-document"></i>
        <a
          href="https://school.jinritemai.com/doudian/web/article/103279?from=shop_settled"
          target="_blank"
          >入驻手册</a
        >
      </div>

      <div class="box">
        <div class="head-tips">
          <p class="tips-title">请选择主体类型</p>
          <p class="tips-warning">
            主体类型一旦选择，认证后无法修改，请选择符合要求的主体类型，个人身份证无法入驻
          </p>
        </div>
        <div class="type-box">
          <el-card class="card" shadow="hover">
            <div class="type-title-row">
              <span class="type-title">国内</span>
            </div>
            <div>
              <div class="type-content gt" @click="handleClick(1)">
                <img
                  class="type-icon"
                  src="@/assets/images/simulation/type_icon1.png"
                  alt=""
                />
                <p class="type-name">个体工商户</p>
                <p class="type-tips">适合营业执照类型为“个体工商户”的商家</p>
                <div class="requirement">
                  <p class="one">营业执照“类型”处显示为“个体工商户”</p>
                  <p class="one mt">
                    需要提供营业执照照片<span class="sl" @click.stop="handleLook(1)"
                      >查看示例</span
                    >
                  </p>
                </div>
                <button class="s-btn">立即入驻</button>
              </div>
              <div class="type-content"  @click="handleClick(2)">
                <img
                  class="type-icon"
                  src="@/assets/images/simulation/type_icon2.png"
                  alt=""
                />
                <p class="type-name">企业/公司</p>
                <p class="type-tips">适合营业执照类型为“企业”的商家</p>
                <div class="requirement">
                  <p class="one">
                    营业执照“类型”处显示为“***公司/企业/农民专业合作社”等
                  </p>
                  <p class="one mt">
                    需要提供营业执照照片<span class="sl" @click.stop="handleLook(2)"
                      >查看示例</span
                    >
                  </p>
                </div>
                <button class="s-btn">立即入驻</button>
              </div>
            </div>
          </el-card>
          <el-card class="card ml" shadow="hover">
            <div class="type-title-row">
              <span class="type-title">跨境</span>
            </div>
            <div class="type-content"  @click="handleClick(3)">
              <img
                class="type-icon"
                src="@/assets/images/simulation/type_icon3.png"
                alt=""
              />
              <p class="type-name">跨境商家</p>
              <p class="type-tips">仅限海外注册公司的商家</p>
              <div class="requirement">
                <p class="one">需要提供注册登记证</p>
                <p class="one mt">
                  若公司注册地为香港，只需提供《公司注册证书》（CR）和《商业登记条例》（BR）
                </p>
              </div>
              <button class="s-btn">立即入驻</button>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="srcList"
    />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      showViewer: false,
      srcList: [],
    };
  },
  methods: {
    handleLook(type) {
      if (type == 1) {
        this.srcList = [require("@/assets/images/simulation/slgt.png")];
      } else {
        this.srcList = [require("@/assets/images/simulation/slqy.png")];
      }
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
    handleClick(type) {
      if (type == 1 || type == 2) {
        this.$router.push({
          name: 'step',
          query: {
            type,
            mobile: this.$route.query.mobile
          }
        })
      } else {
        this.$message.warning('未开放')
      }
    }
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100vh;
  background: rgb(246, 246, 250);
  .top-row {
    padding: 16px 0;
    color: #1966ff;
    text-align: right;
  }
  .box {
    padding: 48px 0;
    min-height: calc(100vh - 70px);
    background: #fff;
    border-radius: 4px;
    .tips-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: #12141a;
    }
    .tips-warning {
      margin-top: 8px;
      line-height: 20px;
      color: #85878a;
    }
    .type-box {
      margin-top: 32px;
      .card {
        display: inline-block;
        padding: 24px 46px 32px;
        &.ml {
          margin-left: 42px;
        }
        .type-title-row {
          .type-title {
            line-height: 28px;
            font-weight: 500;
            font-size: 20px;
            color: #12141a;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              left: -64px;
              top: 50%;
              transform: translateY(-50%);
              width: 48px;
              height: 2px;
              background: url("../../../assets/images/simulation/title-left.svg")
                no-repeat center center;
              background-size: contain;
            }
            &::after {
              content: "";
              position: absolute;
              right: -64px;
              top: 50%;
              transform: translateY(-50%) rotateZ(180deg);
              width: 48px;
              height: 2px;
              background: url("../../../assets/images/simulation/title-right.svg")
                no-repeat center center;
              background-size: contain;
            }
          }
        }

        .type-content {
          position: relative;
          display: inline-block;
          margin-top: 24px;
          width: 260px;
          height: 326px;
          vertical-align: top;
          cursor: pointer;
          &.gt {
            margin-right: 42px;
          }
          &:hover {
            .s-btn {
              background: #4784ff;
              color: #fff;
              border-color: transparent;
            }
          }
          .type-icon {
            width: 96px;
            height: 96px;
          }
          .type-name {
            margin-top: 24px;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #12141a;
          }
          .type-tips {
            margin-top: 8px;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #55585c;
          }
          .requirement {
            margin-top: 24px;
            .one {
              position: relative;
              padding-left: 12px;
              font-size: 12px;
              line-height: 16px;
              color: #85878a;
              text-align: left;
              &.mt {
                margin-top: 16px;
              }
              &::before {
                position: absolute;
                content: "";
                display: block;
                width: 4px;
                height: 4px;
                left: 0;
                top: 6px;
                background: #4784ff;
                border-radius: 50%;
              }
              .sl {
                padding-left: 4px;
                color: #1966ff;
                cursor: pointer;
              }
            }
          }
          .s-btn {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            padding: 6px 16px;
            border-radius: 4px;
            box-shadow: none;
            color: #1966ff;
            background: #fff;
            border: 1px solid #1966ff;
            transition: all 0.3s ease;
          }
        }
      }
    }
  }
}
</style>